import { render } from "./favorites-menu.vue?vue&type=template&id=2fbcf2a4"
import script from "./favorites-menu.vue?vue&type=script&lang=js"
export * from "./favorites-menu.vue?vue&type=script&lang=js"
script.render = render

export default script